<svg width="0" height="0">
  <defs>
    <clipPath id="shaped-image-front-clip-path">
      <path d="
        M205.592 25.9692C205.122 25.7968 204.652 25.6245 204.17 25.4521C171.023 13.6978 135.376 3.15003 99.8552 7.13705
        C63.9562 11.17 28.2061 31.8176 14.39 65.2764C1.14709 97.345 10.0445 134.756 26.8532 165.101
        C43.6619 195.447 67.7284 221.035 87.5525 249.484C101.564 269.58 113.465 291.147 123.039 313.713
        C132.968 337.13 137.658 371.106 162.011 384.457C206.222 408.689 243.818 362.672 272.242 335.268
        C326.532 282.943 449.846 225.504 442.702 136.147C438.689 85.9469 395.143 57.9803 347.17 61.749
        C296.286 65.736 251.936 42.9284 205.592 25.9806V25.9692Z" />
    </clipPath>

    <clipPath id="shaped-image-mobile-front-clip-path">
      <path d="
        M239.997 104.05C239.997 61.4919 240.615 12.1079 162.105 0.892171C114.728 -5.87495 102.625 27.107 45.4018 57.4365
        C-8.40208 85.9564 0.559572 117.11 0.559572 118.47C0.559572 158.434 24.7147 180.466 54.0141 202.125
        C71.4273 212.934 96.7862 219.853 126.216 219.998C146.507 220.098 162.95 216.18 175.942 210.797
        C213.923 191.204 240 150.76 240 104.047L239.997 104.05Z" />
    </clipPath>

    <clipPath id="shaped-image-mobile-back-clip-path">
      <path d="
        M231.269 155.32C249.255 116.75 270.685 72.2536 204.271 28.909C164.193 2.75352 139.285 27.5303 74.6054 30.8348
        C13.7895 33.9441 8.74542 65.9661 8.1707 67.1986C-8.71902 103.419 3.86181 133.595 21.2627 165.607
        C32.4764 182.762 52.5354 199.75 79.1467 212.319C97.4941 220.985 114.052 224.383 128.102 224.995
        C170.805 223.289 211.531 197.655 231.273 155.319L231.269 155.32Z" />
    </clipPath>

    <clipPath id="shaped-image-back-clip-path">
      <path d="
      M229.331 33.9749C228.889 33.7388 228.448 33.5027 227.995 33.265C196.806 17.0119 162.974 1.60566 127.244 0.610355
      C91.1332 -0.392093 52.8575 15.079 34.5192 46.2894C16.9421 76.2029 20.5463 114.488 32.9682 146.878
      C45.3901 179.267 65.6612 207.955 81.3331 238.887C92.411 260.737 101.195 283.75 107.535 307.429
      C114.109 332 114.024 366.298 136.282 382.909C176.691 413.058 220.326 372.721 252.286 349.54
      C313.33 305.279 443.438 265.562 448.8 176.08C451.813 125.81 412.582 92.0548 364.552 89.1104
      C313.607 85.9768 272.864 57.2189 229.329 33.9863L229.331 33.9749
      Z" />
    </clipPath>
  </defs>
</svg>
